import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'
import React, { useState } from 'react'
import { Color } from '../../../../../../chess/types'
import { useScreenSize } from '../../../../../../sharedComponents/src/hooks/useScreenSize'
import { GameResult } from '../../../../../../store/types'
import { getFeedbackMessage } from '../../utils'

interface IProps {
    result: GameResult
    myColor?: Color
    observer: boolean
}

const FeedbackMessage: React.FC<IProps> = ({ result, myColor, observer }) => {
    const { isMobile } = useScreenSize()
    const [feedback] = useState(() => getFeedbackMessage(result, myColor))

    if (feedback === '' || observer) return null

    return (
        <Stack>
            <Typography variant={isMobile ? 'body4' : 'body3'} textAlign="center">
                {feedback}
            </Typography>
        </Stack>
    )
}

export default FeedbackMessage
